export default __webpack_public_path__ + "static/media/wanna5.26f06fd7.webp";